import { Amount } from "~/components/in-year-budget-requests/constants/amounts";

export function formatToDecimals(value: number, decimals: number): number {
    return !isNaN(value) && value !== null ? (Math.round(value * 10 ** decimals) / 10 ** decimals) : 0;
}

export function convertToMillions(value: number): number {
    return !isNaN(value) && value !== null ? value * Amount.ONE_MILLION : 0;
}
